import { useContext } from 'react'
import { AppContext } from '@state/context'
import useSWR from 'swr'
import { SchoolGroups_Listing } from '@graphql/queries'

const useSchoolGroups = () => {
  const [state] = useContext(AppContext)
  const {
    app: { userId },
  } = state

  const { data, error, mutate, isValidating } = useSWR([
    SchoolGroups_Listing,
    userId,
  ])

  const schoolGroups = data?.schoolGroups?.data
    ? data?.schoolGroups?.data
    : []

  const sortedSchoolGroups = schoolGroups.sort(
    (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() && 1) || -1
  )

  return {
    schoolGroups: sortedSchoolGroups,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useSchoolGroups }
